import Cookies from "js-cookie";
import { IAM_COOKIE_DOMAIN } from "../settings/config"

export interface CookieAttributes {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: "strict" | "Strict" | "lax" | "Lax" | "none" | "None" | undefined;
}

const defaultIamCookieAttributes: CookieAttributes = {
    path: "/",
    domain: IAM_COOKIE_DOMAIN,
    sameSite: "strict"
};

function setCookie(name: string, value: string, options?: CookieAttributes): string | undefined {
    return Cookies.set(name, value, options);
}

function getCookie(name: string): string | undefined {
    return Cookies.get(name);
}

function getCookieJson(name: string): Record<string, any> | null {
    let cookieValue = Cookies.get(name);

    if (cookieValue) {
        try {
            const parsedCookieValue = JSON.parse(cookieValue);
            return parsedCookieValue;
        } catch (e) {
            return null;
        }
    }
    return null;
}

function removeCookie(name: string, options?: CookieAttributes): void {
    Cookies.remove(name, options);
}

export { setCookie, getCookie, getCookieJson, removeCookie, defaultIamCookieAttributes };
